module.exports = __webpack_public_path__ + "static/derro-0cc7cf7d247337609eeed55d854830cb.png";